import { Suspense, useEffect } from "react";
import { useRoutes } from "react-router-dom";
import { routes } from "./routes";
import { useUIStore } from "@/lib/store";

function LoadingFallback() {
  return (
    <div className="flex h-screen items-center justify-center bg-warmgray-50">
      <div className="text-center">
        <div className="mx-auto h-12 w-12 animate-spin rounded-full border-4 border-bark-200 border-t-bark-600" />
        <p className="mt-4 text-sm text-warmgray-500">Loading...</p>
      </div>
    </div>
  );
}

export default function App() {
  const element = useRoutes(routes);
  const darkMode = useUIStore((s) => s.darkMode);

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);

  return <Suspense fallback={<LoadingFallback />}>{element}</Suspense>;
}
